import classNames from 'classnames';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getRules, useRequiredFieldValidator } from '@steelbuy/ui-domain';
import { InputTextAreaCharacterCount } from '@steelbuy/ui-primitive';
import { FormData } from '../bulkListingUtil';

export const BulkListingDescriptionInput = ({
    isPrime,
    control,
    validationRules,
}: {
    isPrime: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: Control<FormData, any>;
    validationRules: ReturnType<typeof getRules>;
}) => {
    const { t } = useTranslation(['uiDomain']);
    const requiredFieldValidator = useRequiredFieldValidator();
    return (
        <div className={classNames('input-description', { 'input-description--non-prime': !isPrime })}>
            <Controller
                name="description"
                control={control}
                rules={isPrime ? {} : validationRules.required()}
                render={({ field: { value, onChange } }) => (
                    <InputTextAreaCharacterCount
                        name="materialDescription"
                        label={
                            isPrime
                                ? t('uiDomain:materialQualitySelection.descriptionPrimeLabel')
                                : t('uiDomain:materialQualitySelection.descriptionLabel')
                        }
                        placeholder={
                            isPrime
                                ? t('uiDomain:materialQualitySelection.descriptionPrimePlaceholder')
                                : t('uiDomain:materialQualitySelection.descriptionPlaceholder')
                        }
                        onChange={onChange}
                        value={value}
                        validators={isPrime ? undefined : [requiredFieldValidator]}
                        forceValidation={!isPrime}
                    />
                )}
            />
        </div>
    );
};
